angular.module( 'acme.view.application.passes.modals.remove', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.modals.remove.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesModalsRemove = {
        name: 'application.passes.modals.remove',
        url: '/passes/modals/remove',
        views: {
          "main": {
            controller: 'PassesModalsRemoveController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/modals/remove/remove.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(passesModalsRemove);
});
